import { Flex, Grid, GridItem, Tabs } from "@chakra-ui/react";
import { UploadInfoBox } from "./UploadInfoBox";
import { LandingPageFileUploader } from "./FileUploader";
import { useTranslation } from "react-i18next";
import { ClaimsTab } from "./claimTab";
import { InvoiceTab } from "./invoiceTab";

export const LandingPage = () => {
    return (
        <Flex
            flexDir="column"
            alignItems="center"
            minH="100vh"
            pt="3rem"
            px="2.5rem"
            gap="2.5rem"
            mx="auto"
            maxWidth={{ base: "100%", lg: "110rem" }}
        >
            <Grid templateColumns="repeat(4, 1fr)" gap="2rem" w="full">
                <GridItem colSpan={3} h="full">
                    <LandingPageFileUploader />
                </GridItem>
                <GridItem colSpan={1} h="full">
                    <UploadInfoBox />
                </GridItem>
            </Grid>
            <LandingPageTabs />
        </Flex>
    );
};

const LandingPageTabs = () => {
    const { t } = useTranslation(["claimsInvoicesOverview", "errorMessages"]);
    const tabs = [
        {
            label: t("claimsInvoicesOverview:tabInvoices"),
            component: <InvoiceTab />,
            testId: "tabInvoices",
            value: "invoices"
        },
        {
            label: t("claimsInvoicesOverview:tabClaims"),
            component: <ClaimsTab />,
            testId: "tabClaims",
            value: "claims"
        }
    ];
    return (
        <Flex
            justifyContent="center"
            width="100%"
            bg="white"
            borderRadius="lg"
            p="1.5rem 2rem 3rem 2rem"
            border="1px solid"
            borderColor="gray.100"
            boxShadow="0px 2px 8px 0px #00000014"
        >
            <Tabs.Root
                w="100%"
                lazyMount
                defaultValue="invoices"
                variant="plain"
                css={{ "--tabs-trigger-radius": "radii.full" }}
            >
                <Tabs.List id="mainTablist" justifySelf="start" gap="0.5rem">
                    <Tabs.Indicator />
                    {tabs.map(tab => (
                        <Tabs.Trigger
                            key={tab.testId}
                            value={tab.value}
                            data-testid={tab.testId}
                            border="solid 1px"
                            borderColor="anchor.gray.100"
                            bg="white"
                            css={{ _selected: { color: "white", bg: "var(--a-navy-900)" } }}
                        >
                            {tab.label}
                        </Tabs.Trigger>
                    ))}
                </Tabs.List>
                {tabs.map(tab => (
                    <Tabs.Content key={tab.testId} value={tab.value}>
                        {tab.component}
                    </Tabs.Content>
                ))}
            </Tabs.Root>
        </Flex>
    );
};
